import { useCallback } from 'react';
import sendAiGenScreenActionAnalytics from '@/utils/analytics/sendAiGenScreenActionAnalytics';
import { AiGenScreenAction, ScreenType } from '@/types/analytics';

interface UseMediaUploadOptions {
  uploadMedia: (file: File, id: string) => void;
  isAuthorized: boolean | undefined;
  addPendingUpload: (upload: { id: string; file: File }) => void;
}

const useMediaUpload = ({
  uploadMedia,
  isAuthorized,
  addPendingUpload,
}: UseMediaUploadOptions) => {
  const handleMediaUpload = useCallback(
    async (id: string, file: File): Promise<boolean> => {
      // If not authorized, store file for later CDN upload
      // Login popup will appear when user clicks Generate
      // Let useFileUpload handle the local preview (avoids duplicate blob URLs)
      if (!isAuthorized) {
        addPendingUpload({ id, file });
        return true; // Preview will be handled by useFileUpload
      }

      sendAiGenScreenActionAnalytics({
        action: AiGenScreenAction.UPLOAD,
        screen_type: ScreenType.GENERATOR,
      });

      uploadMedia(file, id);
      return true;
    },
    [uploadMedia, isAuthorized, addPendingUpload]
  );

  return { handleMediaUpload };
};

export default useMediaUpload;
